import { RightSizePricingComponent } from '@eventbrite/wagtail-components';

export default RightSizePricingComponent;
